module.exports = __webpack_public_path__ + "img/banner9.cc03ef03.png";